import { Divider } from "primereact/divider";
import Container from "../Container";
import Currency from "../Currency";
import Text from "../Text";

interface IAssetAllocationCardItem {
    name: string;
    percentage: number;
    value: number;
}

interface IAssetAllocationCardItemProps extends IAssetAllocationCardItem {
    color: string;
}

// eslint-disable-next-line react-refresh/only-export-components
export const colors = [
    "bg-fixed-income",
    "bg-variable-income",
    "bg-cashflow-income",
    "bg-vehicles",
    "bg-properties"
];

const AssetAllocationCardItem = ({ name, percentage, value, color }: IAssetAllocationCardItemProps) => {
    const percentageCard = Math.round(percentage * 100) / 100;
    return (
        <Container
            flexColumn
            className={`border-round ${colors.includes(color) || color.startsWith("bg") ? color : ''} p-3`}
            style={{
                width: `${percentageCard > 100 ? 100 : percentageCard}%`,
                minWidth: `${percentageCard > 15 ? `${percentageCard > 100 ? 100 : percentageCard}%` : `calc(130px + ${Math.round(percentage * 100) / 100}%)`}`,
                backgroundColor: `${colors.includes(color) || color.startsWith("bg") ? '' : color}`
            }}
        >
            <Text color="white" size="sm" showEllipsis>{name}</Text>

            <Divider />

            <Container flexColumn>
                <Text color="white" fontWeight="semibold" size="lg">{percentage.toFixed(4)}%</Text>
                <Currency value={value}>
                    {
                        (value) => (
                            <Text color="white" size="sm" fontWeight="normal">{value}</Text>
                        )
                    }
                </Currency>
            </Container>
        </Container>
    )
}

export default AssetAllocationCardItem;
